import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { url_login } from "../Func_genericas/hosts";

/** extrai mensagem amigável de respostas tipo FastAPI `{ detail: string | [...] }` */
const formatApiDetail = (body: unknown): string | undefined => {
  if (!body || typeof body !== "object") return undefined;
  const d = (body as { detail?: unknown }).detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const parts = d
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object" && "msg" in item)
          return String((item as { msg: unknown }).msg);
        return "";
      })
      .filter(Boolean);
    return parts.length ? parts.join(" ") : undefined;
  }
  return undefined;
};

export const get_token = async (obj: any) => {

  try {
    let servico = 'login'
    // let servico = 'autentica'

    let res = await axios.post(url_login + servico, obj, { headers: { 'Content-Type': 'application/json' } })

    if (res.status === 200) {
      const token: any = res.data.access_token.length !== 0 ? jwtDecode(res.data.access_token) : '';

      return { flag: true, data: res.data.access_token, token: token };

    } else if (res.status === 401) {
      return { flag: false, data: res };

    } else {

      return { flag: false, data: res };
    }

  } catch (e: any) {
    if(e.message.includes('401')){
    return { flag: false, error: 'Credenciais incorretas.' };

    }else{
      return { flag: false, data: e.toString() };

    }



  }
}

export const get_token_agricultor = async (obj: any) => {

  try {
    let servico = 'login_agricultor'
    // let servico = 'autentica'

    let res = await axios.post(url_login + servico, obj, { headers: { 'Content-Type': 'application/json' } })

    if (res.status === 200) {
      const token: any = res.data.access_token.length !== 0 ? jwtDecode(res.data.access_token) : '';

      return { flag: true, data: res.data.access_token, token: token };

    } else if (res.status === 401) {
      return { flag: false, data: res };

    } else {

      return { flag: false, data: res };
    }

  } catch (e: any) {
    const detail = formatApiDetail(e?.response?.data);
    if (detail) return { flag: false, error: detail };
    if (e?.response?.status === 401 || (typeof e?.message === "string" && e.message.includes("401"))) {
      return { flag: false, error: "Credenciais incorretas." };
    }
    return { flag: false, error: "Erro ao efetuar a sua operação!" };
  }
}

export const registar_organizacao = async (obj: any) => {
  try {
    const servico = "registar_organizacao";
    const res = await axios.post(url_login + servico, obj, {
      headers: { "Content-Type": "application/json" },
    });

    if (res.status === 200 || res.status === 201) {
      return { flag: true, data: res.data };
    }

    return { flag: false, data: res };
  } catch (e: any) {
    if (e?.response?.data?.message) {
      return { flag: false, error: e.response.data.message };
    }

    if (typeof e?.message === "string" && e.message.includes("401")) {
      return { flag: false, error: "Operação não autorizada." };
    }

    return { flag: false, error: "Erro ao efetuar a sua operação!" };
  }
};

// export const useApi = () => ({

//   signin: async (dados: any) => {
//     try {

//       const response = await api.post("/autentica", dados, {
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       });


//       if (response.status === 200) {
//         const token: any = jwtDecode(response.data.access_token);

//         // localStorage.setItem('token', response.data.access_token);
//         return { flag: true, data: response, token: token };

//       } else if (response.status === 401) {
//         // localStorage.removeItem("token");
//         return { flag: false, data: response };

//       } else {
//         return { flag: false, data: response };

//       }

//     } catch (error: any) {

//       func_print('error useApi', error, true)

//       return { flag: false, data: error.toString() };

//     }
//   },


// });